// ---------------------------------------------------------------------------
// Portfolio content — sourced from Anusree Prakashan's résumé and LinkedIn.
// ---------------------------------------------------------------------------

export const profile = {
  name: "Anusree Prakashan",
  first: "Anusree",
  last: "Prakashan",
  monogram: "AP",
  pronouns: "She / Her",
  role: "Computer Engineering student · .NET & Flutter developer",
  tagline:
    "I like software that holds up when people depend on it — a database that stays honest, a service that fails loudly, a screen that feels calm in the hand. I'm looking for an internship where I can learn that craft properly.",
  location: "Thalassery, Kerala, India",
  timezone: "IST · UTC+5:30",
  availability: "Open to internships — Bengaluru, hybrid or remote",
  email: "anusreeprakashan1105@gmail.com",
  phone: "+91 88481 98404",
  linkedin: "https://www.linkedin.com/in/anusree-prakashan-3b3166217/",
  linkedinLabel: "linkedin.com/in/anusree-prakashan",
  resume: "/resume.pdf",
};

export const about = [
  "I'm a B.Tech Computer Engineering student with a strong footing in programming and problem-solving, and a growing pull toward DevOps. Before my degree I finished a diploma in Computer Engineering, so I've had a few years to work out how I like to build: understand the problem first, keep the design small, and leave things clearer than I found them.",
  "For six months I worked as a software developer intern at MNI in Bangalore, building desktop and web applications on the .NET stack. Writing SQL schemas, wiring services with dependency injection, and testing features taught me more about how a team actually ships than any single course did.",
  "Right now I'm looking for an internship where I can deepen that practical knowledge, contribute to real products, and keep learning from people who care about their work.",
];

export const glance = [
  { label: "Studying", value: "B.Tech, Computer Engineering" },
  { label: "Since", value: "2024 — present" },
  { label: "Before", value: "Diploma, Computer Engineering" },
  { label: "Experience", value: "6 months in a product team" },
  { label: "Based in", value: "Thalassery, Kerala" },
  { label: "Looking for", value: "A software internship" },
];

export const experience = [
  {
    role: "Software Developer Intern",
    org: "MNI Pvt Ltd.",
    place: "Bangalore, Karnataka",
    period: "Feb 2023 — Jul 2023",
    duration: "6 months",
    summary:
      "A small product team building desktop and web applications on the .NET stack — my first real look at shipping software to people who use it.",
    points: [
      "Built desktop and web applications with C# and the .NET framework, working from senior developers' briefs.",
      "Designed databases in SQL Server for storage and retrieval, thinking about schema before screens.",
      "Wired services together with dependency injection so features stayed testable and easy to replace.",
      "Wrote unit tests for new features and grew through regular code reviews and technical discussions.",
    ],
    skills: ["C#", ".NET", "SQL Server", "Dependency injection", "Unit testing"],
  },
];

export const projects = [
  {
    title: "System Health Monitoring Script",
    year: "2023",
    blurb: "A quiet watchman for a Linux machine.",
    description:
      "A script that keeps an eye on a Linux system — CPU load, memory consumption, disk space, and running processes — and reports its health before something falls over.",
    tags: ["Linux", "Shell scripting", "System monitoring"],
    featured: true,
  },
  {
    title: "Face Detection for Exam Authentication",
    year: "2024",
    blurb: "Exams that start with a face, not a password.",
    description:
      "A secure, face-based login for exam sittings. It captures the candidate in real time and verifies identity with InsightFace, so an exam can begin without passwords, tokens, or a proctor at the door.",
    tags: ["Python", "Streamlit", "OpenCV", "InsightFace"],
  },
  {
    title: "Movie Management Application",
    year: "2023",
    blurb: "A small app that takes security seriously.",
    description:
      "A secure application for managing a movie catalogue — authentication, authorization, and efficient CRUD over movie data — built with dependency injection so the pieces stay independent and testable.",
    tags: ["C#", ".NET", "SQL Server", "Authentication"],
  },
];

export const skillGroups = [
  { title: "Languages", items: ["C#", "Dart", "SQL"] },
  { title: "Frameworks", items: [".NET", "Flutter"] },
  { title: "Databases", items: ["SQL Server", "MySQL"] },
  { title: "Web", items: ["HTML", "CSS"] },
  { title: "Tools", items: ["Git", "VS Code", "Linux"] },
  { title: "Practice", items: ["Problem solving", "Communication", "DevOps fundamentals"] },
];

export const education = [
  {
    qualification: "B.Tech, Computer Science & Engineering",
    org: "APJ Abdul Kalam Technological University",
    place: "Kerala, India",
    period: "2024 — present",
    note: "Currently studying",
  },
  {
    qualification: "Diploma, Computer Engineering & IT Infrastructure",
    org: "Nettur Technical Training Foundation",
    place: "Kerala, India",
    period: "2020 — 2023",
    note: "Completed",
  },
];

export const training = [
  {
    title: "Cross-platform UI with Flutter",
    org: "Neovent Innovations",
    period: "2 weeks",
    description:
      "Built cross-platform UI components with Dart and Flutter, and got hands-on with mobile state management and responsive layout.",
    tags: ["Dart", "Flutter", "State management"],
  },
];

export const nav = [
  { href: "#about", label: "About" },
  { href: "#experience", label: "Experience" },
  { href: "#work", label: "Work" },
  { href: "#toolkit", label: "Toolkit" },
  { href: "#education", label: "Education" },
  { href: "#contact", label: "Contact" },
];
